"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SongwriterCatalogBuilderHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null,
        "Enter the name you wish to search in the Writer Name field, then click the ",
        react_1.default.createElement("strong", null, "Search"),
        " button. From the results, select all versions of the writer name you have the rights to by clicking the",
        ' ',
        react_1.default.createElement("strong", null, "Add to Catalog"),
        " toggle, which will change to ",
        react_1.default.createElement("strong", null, "In Catalog"),
        " once the writer name has been added."),
    react_1.default.createElement("br", null),
    react_1.default.createElement("p", null, "NOTE: Before adding a name to your catalog, please confirm it is the correct writer name by reviewing the associated IPI Number or by clicking the blue link showing the number of titles, which will show you songs associated with that name.")));
exports.default = SongwriterCatalogBuilderHeader;
